const findAndUpdateGrade = ({ grades, studentId, grade }) =>
  grades.map((_grade) => {
    if (_grade.studentId === studentId) {
      return { ..._grade, grade };
    }
    return _grade;
  });

export default findAndUpdateGrade;
